import ENDPOINTS from '../../constants/apiEndPoints';
import {UserFormPayload} from '../../pages/users/components/UserScreens/components/AddEditUserDialog';
import {
  SingleUserResponse,
  UserQueryParams,
  UsersListResponse,
} from '../../pages/users/components/UserScreens/users';
import {ApiResponse, axiosInstance} from '../axiosInstance';

type GenericObject = {
  [key: string]: any;
};

export const handleLoginService = async (payload: GenericObject) => {
  const response = await axiosInstance.post(ENDPOINTS.LOGIN, payload);
  return response?.data;
};

export const handleCreateUserService = async (payload: UserFormPayload) => {
  const response = await axiosInstance.post(ENDPOINTS.GET_CREATE_USER, payload);
  return response?.data;
};

export const handleGetAllUsersService = async (
  params?: UserQueryParams,
): Promise<ApiResponse<UsersListResponse>> => {
  const response = await axiosInstance.get(ENDPOINTS.GET_CREATE_USER, {params});
  return response?.data;
};

export const handleGetUserService = async (
  id: string,
): Promise<ApiResponse<SingleUserResponse>> => {
  const response = await axiosInstance.get(
    ENDPOINTS.GET_UPDATE_DELETE_USER(id),
  );
  return response?.data;
};

export const handleUpdateUserService = async (
  id: string,
  payload: UserFormPayload,
) => {
  const response = await axiosInstance.put(
    ENDPOINTS.GET_UPDATE_DELETE_USER(id),
    payload,
  );
  return response?.data;
};

export const handleDeleteUserService = async (id: string) => {
  const response = await axiosInstance.delete(
    ENDPOINTS.GET_UPDATE_DELETE_USER(id),
  );
  return response?.data;
};

export const handleDeleteBulkUserService = async (payload: {
  users: string[];
}) => {
  const response = await axiosInstance.delete(ENDPOINTS.DELETE_BULK_USERS, {
    data: payload,
  });
  return response?.data;
};

export const handleCreateBulkUserService = async (payload: {
  duplicateAction: string;
  users: UserFormPayload[];
}) => {
  const response = await axiosInstance.post(
    ENDPOINTS.CREATE_BULK_USERS,
    payload,
  );
  return response?.data;
};

export const handleResetUserPasswordService = async (payload: {
  email: string;
}) => {
  const response = await axiosInstance.post(
    ENDPOINTS.RESET_USER_PASSWORD,
    payload,
  );
  return response?.data;
};

export const handleChangeUserPasswordService = async (payload: {
  oldPassword: string;
  newPassword: string;
}) => {
  const response = await axiosInstance.put(
    ENDPOINTS.CHANGE_USER_PASSWORD,
    payload,
  );
  return response?.data;
};

export const handleDepartmentManagersService = async (
  params: Record<string, any>,
) => {
  const response = await axiosInstance.get(ENDPOINTS.GET_DEPARTMENT_MANAGERS, {
    params,
  });
  return response?.data;
};

export const handleUpdateLanguageService = async (payload: GenericObject) => {
  const response = await axiosInstance.put(ENDPOINTS.UPDATE_LANGUAGE, payload);
  return response?.data;
};

export type FcmTokenPayload = {
  fcmToken: string;
  platform: 'web';
  deviceId: string;
  replaceToken?: string;
};

export const handleUpdateFcmTokenService = async (payload: FcmTokenPayload) => {
  const response = await axiosInstance.put(ENDPOINTS.UPDATE_FCM_TOKEN, payload);
  return response?.data;
};

export const handleRemoveFcmTokenService = async (fcmToken: string) => {
  // Short timeout: runs during logout and must not hold it up
  const response = await axiosInstance.delete(ENDPOINTS.REMOVE_FCM_TOKEN, {
    data: {fcmToken},
    timeout: 5000,
  });
  return response?.data;
};
